/* src/app/private/components/leads/lead-followup-form/lead-followup-form.component.scss */
.profile-select {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.profile-input {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.requiredValue::after {
  content: "*";
  color: red;
}
/*# sourceMappingURL=lead-followup-form.component.css.map */
